import Vue from 'vue'
import Router from 'vue-router'
import Login from 'views/auth/Layout'
import Layout from 'views/portal/layout/Layout'
import { store } from '../store'
import cookie from 'js-cookie'

Vue.use(Router)

// SET_AUTH_STATUS error code => events/errorCodes.js
// 語言包翻譯func mixins/global.js

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', redirect: '/login', meta: { requireAuth: false } },
    { path: '/login',
      component: Login,
      meta: { requireAuth: false },
      name: 'login',
      alias: '/'
    },
    { path: '/resetPw',
      component: Login,
      meta: { requireAuth: false },
      name: 'resetPw'
    },
    { path: '/admin',
    component: Login,
    meta: { requireAuth: false },
    name: 'admin'
    },
    { path: '/adminLogin',
    component: Login,
    meta: { requireAuth: false },
    name: 'adminLogin'
    },
    { path: '',
      component: Layout,
      redirect: 'index',
      meta: { requireAuth: true },
      children: [{
        path: 'index',
        component: () => import('views/portal/Dashboard'),
        name: 'dashboard',
        meta: {
          title: 'dashboard',
          breadcrumb: [
            {title: '總覽'}
          ]
        }
      }]
    },
    { path: '/stores',
      component: Layout,
      meta: { requireAuth: true },
      children: [{
        path: '',
        component: () => import('views/portal/store/StoreProfile'),
        name: 'storeProfile',
        meta: {
          title: 'storeProfile',
          breadcrumb: [
            {title: '帳號資訊'}
          ]
        }
      }]
    },
    { path: '/reports',
      component: Layout,
      meta: { requireAuth: true },
      children: [{
        path: 'sales',
        component: () => import('views/portal/report/SalesReport'),
        name: 'SalesReport',
        meta: {
          title: 'salesReport',
          breadcrumb: [
            {title: '交易明細'}
          ]
        }
      }, {
        path: 'billing',
        component: () => import('views/portal/report/BillingReport'),
        name: 'BillingReport',
        meta: {
          title: 'billingReport',
          breadcrumb: [
            {title: '帳務明細'}
          ]
        }
      }]
    },
    { path: '/reports/sales/print',
      component: () => import('views/portal/report/components/SalesPrint'),
      meta: { requireAuth: true }
    },
    { path: '/reports/billing/print',
      component: () => import('views/portal/report/components/BillingPrint'),
      meta: { requireAuth: true }
    },
    { path: '/notifications',
      component: Layout,
      meta: { requireAuth: true },
      children: [{
        path: '',
        component: () => import('views/portal/notification/Notifications'),
        name: 'notification',
        meta: {
          title: 'notification',
          breadcrumb: [
            {title: '訊息通知'}
          ]
        }
      }]
    },
    { path: '*', component: () => import('views/errors/Layout') }
  ]
})

router.beforeEach((to, from, next) => {
  store.commit('SET_PAGE_LOADING_STATUS', true)
  let authMatch = to.matched.some(record => {
    return record.meta.requireAuth
  })
  let token = cookie.get('CT')
  let googleToken = cookie.get('GT')
  if (authMatch) {
    // 需要認證頁面，已取得token
    if (token) {
      if (process.env.NODE_ENV !== 'production') console.log('keep going')
      next()
    } else {
      // 需要認證頁面，沒有token
      if (process.env.NODE_ENV !== 'production') console.log('no auth')
      store.commit('SET_AUTH_STATUS', '401-002')
      if (from.path === '/' || from.path === '/login') {
        // 如果重新整理 或者從 登入頁 進入，就直接返回登入頁
        next('/login')
      } else {
        // 如果是從 內部頁面 觸發，則顯示 被登出訊息視窗
        store.commit('SET_MODAL_STATUS', {status: true, type: 'info', title: 'errors.authKickOut', subTitle: 'errors.over1hr', btnLink: '/login'})
      }
    }
  } else {
    // 如果執行登出功能，必須將 token 清除後才可正常回到 login 頁面
    if (token) {
      // 無需驗證的頁面(login, resetPw)，如果存在登入權限，則導回 index
      if (to.path === '/login' || 'resetPw') {
        next('/index')
        // 導回 index 後需清除 loading 狀態(不會經過router.afterEach)
        store.commit('SET_PAGE_LOADING_STATUS', false)
      } else {
        next()
      }
    } else {
      if (from.path !== '/' && '/login' && 'resetPw') {
        // 無token代表被登出，紀錄被登出前的位置，下次登入直接導回
        store.commit('SET_RECORD_PATH', from.path)
      }
      if(googleToken && to.path === '/admin' ){
          next('/adminLogin')
      }if(to.path === '/adminLogin' && !googleToken){
        next('/admin')
      }
     
      next()
    }
  }
})

router.afterEach((to, from) => {
  setTimeout(() => {
    store.commit('SET_PAGE_LOADING_STATUS', false)
  }, 500)
})

export default router
